import React from 'react'
import styled from 'styled-components'
import { Input } from '@giphy/react-giphy-brand'

export const TITLE_MAX_LENGTH = 50

const StyledInput = styled(Input)`
    height: 36px;
    margin: 0;
`

type Props = {
    value: string
    onChange?: Function
}

const TitleInput = ({ value = '', onChange = () => {} }: Props) => {
    const charCount = value.length
    const isTooLong = charCount > TITLE_MAX_LENGTH
    return (
        <StyledInput
            errorTooltip={true}
            errorMessage={isTooLong ? `You've run out of characters! (${charCount}/${TITLE_MAX_LENGTH})` : ''}
            inputProps={{
                value: value,
                onChange: evt => {
                    onChange(evt.target.value)
                },
                type: 'text',
                placeholder: 'The title of your video',
            }}
        />
    )
}

export default TitleInput
